import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';

/** Whether Shopify's delivery customization is switched on or off when an integration mode is activated */
export const DELIVERY_CUSTOMIZATION_ACTIVE: Record<IntegrationModeSetting, boolean> = {
    [IntegrationModeSetting.map]: true,
    [IntegrationModeSetting.checkout]: true,
    [IntegrationModeSetting.smart_delivery_page]: true,
    [IntegrationModeSetting.checkout_map]: false,
    [IntegrationModeSetting.thank_you_page_map]: false,
};
